var _circle, _circle2, _circle3, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmily(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 61.5,
    stroke: "#00c2ab",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 40,
    r: 10,
    fill: "#00c2ab"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 40,
    r: 10,
    fill: "#00c2ab"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 10,
    width: 97,
    height: 95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.975 57.5C108.975 82.3294 88.6387 102.5 63.5 102.5C38.3613 102.5 18.025 82.3294 18.025 57.5C18.025 32.6706 38.3613 12.5 63.5 12.5C88.6387 12.5 108.975 32.6706 108.975 57.5Z",
    stroke: "#00c2ab",
    strokeWidth: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 23.75,
    transform: "matrix(1 0 0 -1 16.475 113.55)",
    fill: "#00c2ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmily);
export default __webpack_public_path__ + "static/media/smily.e577d79e.svg";
export { ForwardRef as ReactComponent };